export default __webpack_public_path__ + "static/media/photo-francois.04ca2aa6.jpeg";